import { h, render } from 'preact';
import { useState } from 'preact/hooks';

const DemoComponent = () => {
  const [count, setCount] = useState(0);

  return (
    <button type="button" className="button" onClick={() => setCount((c) => c + 1)}>
      {count} - Click me!
    </button>
  );
};

const domContainer = document.querySelector('#demo-component');
if (domContainer) {
  render(<DemoComponent />, domContainer);
}
